import { useCallback, useState } from "react"
import { View, ScrollView, TouchableOpacity } from "react-native"
import { router } from "expo-router"
import { PrimaryButton } from "@/components/buttons/CommonButtons"
import EmailLoadingIcon from "@/assets/clipart/email-loading.svg"
import BuyBox from "@/components/buybox/BuyBoxView"
import { myLeadsSyncViewed } from "@/analytics/events/properties"
import { useViewedCallback } from "@/analytics/react"
import { setStatusBarStyle } from "@/stores/statusBarStyle"
import BFText from "@/components/standard/BFText"

export default function MyLeadsSuccess() {
  const [showBuyBox, setShowBuyBox] = useState<boolean>(false)

  useViewedCallback(() => {
    setStatusBarStyle("light")
    myLeadsSyncViewed()
  })

  const onDismiss = useCallback(() => {
    router.push("../")
  }, [])

  if (showBuyBox) {
    return <BuyBox />
  }

  return (
    <View className="flex flex-col flex-1 bg-midnight-blue">
      <ScrollView className="flex flex-col flex-1 px-6">
        <View className="flex flex-col flex-1 p-6">
          <BFText className="text-teal text-[24px] font-figtree-bold pt-16">
            Hang Tight!
          </BFText>
          <BFText className="text-teal text-[24px] font-figtree-bold">
            Syncing Your Email...
          </BFText>
          <BFText className="text-white text-[16px] font-spacegrotesk mt-4">
            This may take up to 5 minutes to complete. In the meantime, get
            ahead and set up your Buy Box!
          </BFText>
          <View className="flex items-center flex-1 mt-20">
            <EmailLoadingIcon width={211} height={167} />
          </View>
        </View>
      </ScrollView>
      <View className="absolute flex flex-col flex-1 inset-x-10 bottom-10">
        <PrimaryButton
          testID={"buy-box-setup-button"}
          title="Set Up My Buy Box"
          onPress={() => {
            setShowBuyBox(true)
          }}
        />
        <TouchableOpacity
          testID={"close-button"}
          className="flex items-center justify-center flex-1 m-4"
          onPress={onDismiss}
        >
          <BFText className="text-white font-spacegrotesk">
            Not right now
          </BFText>
        </TouchableOpacity>
      </View>
    </View>
  )
}
